import state from './Stock/states'
import mutations from './Stock/mutations'
import actions from './Stock/actions'
import getters from './Stock/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
